/**
 * 项目用户管理相关接口
 * 接口文档
 * @type {{login: string}}
 */
const projectUsers = {
  // 用户管理，获取项目下的用户列表
  getProjectUserPageList: '/api/AccountManagement/GetProjectUserPageList',
  // 生成邀请链接
  makeInvitationToke: '/api/BIMProjectInvitationInternal/MakeInvitationToken',
  // 用户管理-移除项目上的用户
  deleteProjectUser: '/api/Project/RemoveUserFromProject',
  // 用户管理-获取项目用户角色
  getProjectRoles: '/api/AccountManagement/GetProjectRoles',
  // 用户管理-更新项目用户角色
  updateProjectUser: '/api/Project/UpdateProjectUser',
}

Object.freeze(projectUsers)
export default projectUsers
